// extracted by mini-css-extract-plugin
export default {"name":"adminPlanRow__name-Cp4zl","defaultPlanName":"adminPlanRow__defaultPlanName-CKhoq"};